import { useEffect, useState } from 'react';
import { useStargateClient } from '@atlassiansox/bxpkit-core';
import { GetUserPermissionsIsPermittedRequestPermissionId } from '@atlassiansox/asc-stargate';

export type SitePermission = {
  readonly isValidating: boolean;
  readonly isPermitted: boolean;
};

export function useSitePermission(
  siteId: string,
  isBBJSW: boolean
): SitePermission {
  const stargateClient = useStargateClient();
  if (!isBBJSW) {
    return { isValidating: false, isPermitted: true };
  }
  const [{ isValidating, isPermitted }, setValidation] =
    useState<SitePermission>({
      isValidating: false,
      isPermitted: true
    });

  const checkPermissions = async () => {
    await stargateClient
      .getUserPermissionsIsPermitted({
        permissionId: GetUserPermissionsIsPermittedRequestPermissionId.MANAGE,
        resourceId: `ari:cloud:platform::site/${siteId}`,
        dontRequirePrincipalInSite: true
      })
      .then((response) => {
        if (response.permitted) {
          return setValidation({
            isValidating: false,
            isPermitted: true
          });
        } else {
          return setValidation({
            isValidating: false,
            isPermitted: false
          });
        }
      })
      .catch(() => {
        return setValidation({
          isValidating: false,
          isPermitted: false
        });
      });
  };

  useEffect(() => {
    setValidation({ isValidating: true, isPermitted: true });
    checkPermissions().catch(console.error);
  }, [siteId]);

  return { isValidating, isPermitted };
}
